import { render, staticRenderFns } from "./CompoundExport.vue?vue&type=template&id=33fde82a&"
import script from "./CompoundExport.vue?vue&type=script&lang=js&"
export * from "./CompoundExport.vue?vue&type=script&lang=js&"
import style0 from "./CompoundExport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports